import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import useProfile from "@/hooks/useProfile";
import { handleCompanyUserName } from "@/lib/handleName";
import ChangePasswordDialog from "@/src/app/(auth)/_components/ChangePasswordDialog";
import EditProfileDialog from "@/src/app/(auth)/_components/EditProfileDialog";
import { PersonRegular } from "@fluentui/react-icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";

function Avatar() {
  const [editProfileOpen, setEditProfileOpen] = useState(false);
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);

  const { profile } = useProfile();
  const { t } = useTranslation();
  const role = profile
    ? profile.role === 0
      ? t("admin")
      : t("member")
    : "---";
  const name = handleCompanyUserName(profile?.id ?? 0, profile?.name);
  const email = profile?.email ?? "---";
  return (
    <>
      <Popover>
        <PopoverTrigger>
          <div className="flex items-center justify-center rounded-full bg-cool-gray-100 p-2 cursor-pointer">
            <PersonRegular fontSize={20} />
          </div>
        </PopoverTrigger>
        <PopoverContent className="p-0">
          <div>
            <div className="flex flex-col gap-1 items-center border-b p-4">
              <div className="text-base">
                {name} ({role})
              </div>
              <div>{email}</div>
            </div>
            <div className="flex flex-col">
              <div
                onClick={() => setEditProfileOpen(true)}
                className="py-2 px-4 w-full m-auto hover:bg-cool-gray-100 cursor-pointer"
              >
                {t("edit-profile")}
              </div>
              <div
                onClick={() => setChangePasswordOpen(true)}
                className="py-2 px-4 w-full m-auto hover:bg-cool-gray-100 cursor-pointer"
              >
                {t("change-password")}
              </div>
            </div>
          </div>
        </PopoverContent>
      </Popover>
      <EditProfileDialog open={editProfileOpen} setOpen={setEditProfileOpen} />
      <ChangePasswordDialog
        open={changePasswordOpen}
        setOpen={setChangePasswordOpen}
      />
    </>
  );
}

export default Avatar;
